import React from 'react';
import classnames from 'classnames';

import { useAlert } from 'model/alert';

import CheckIcon from 'images/icon/check-circle.inline.svg';
import WarningIcon from 'images/icon/warning-circle.inline.svg';

import Modal from '../Modal';

import styles from './index.css';

export const AlertComponent = ({ className, type, message }) => (
	<div className={classnames(styles.alert, { [styles.warning]: type === 'warning' }, className)}>
		<div className={styles.content}>
			{type === 'warning' ? <WarningIcon /> : <CheckIcon />}
			<span>{message}</span>
		</div>
	</div>
);

const Alert = ({ className }) => {
	const [alert] = useAlert();

	return (
		<Modal className={styles.modal} active={alert.active}>
			<AlertComponent className={className} type={alert.type} message={alert.data} />
		</Modal>
	);
};

export default Alert;
